<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Foreword by Scott Sauls</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction: It’s Time to Talk Back</a></div>
<div class="SOM_chap"><a href="#/chap1"><b>1</b> From Rings and Pledges to Conversation in Community</a></div>
<div class="SOM_chap"><a href="#/chap2"><b>2</b> The Idolization of Virginity</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><b>3</b> Female Responsibilities</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><b>4</b> Male Purity and the Rhetoric of Lust</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><b>5</b> First Comes Love, Then Comes Marriage</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><b>6</b> Problems with the Promise of Sex</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><b>7</b> What the Sexually Abused Hear</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><b>8</b> Submitting to God's Sexual Ethic as Embodied Souls</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><b>9</b> What Will We Tell Our Children?</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><b>10</b> Purity Culture Moving Forward</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Talking Back to Purity Culture</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?4790d3f2